import { render } from "./UploadAtivos.vue?vue&type=template&id=397eedfb&scoped=true"
import script from "./UploadAtivos.vue?vue&type=script&lang=js"
export * from "./UploadAtivos.vue?vue&type=script&lang=js"

import "./UploadAtivos.vue?vue&type=style&index=0&id=397eedfb&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397eedfb"]])

export default __exports__
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFile,QIcon,QBtn});
